import { BlindConfigService } from "../Common/BlindConfigurations/BlindConfigService";
export class Srp30ConfigService extends BlindConfigService {
    constructor() {
        super();
    }
    GetServiceName() {
        return Srp30ConfigService.ServiceName;
    }
}
Srp30ConfigService.ServiceName = "Srp30ConfigService";
//# sourceMappingURL=Srp30ConfigService.js.map